import * as React from "react";

export const BlankPage = () => <div></div>;
